module.exports = __webpack_public_path__ + "static/media/LeftArrow.79e56838.svg";